<template>
  <Table>
    <thead>
      <tr>
        <th data-cy="processing">Processing</th>
        <th data-cy="last-processed">
          Last Processed: {{ datetime(processing.last_processed_at) || "--" }}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr data-cy="processing-total">
        <td>Total</td>
        <td>
          {{ processing.total }}
        </td>
      </tr>
      <tr data-cy="processing-processing">
        <td>Processing</td>
        <td>
          {{ processing.processing }}
        </td>
      </tr>
      <tr data-cy="processing-ignore">
        <td>Ignore</td>
        <td>
          {{ processing.ignore }}
        </td>
      </tr>
      <tr data-cy="processing-processed">
        <td>Processed</td>
        <td>
          {{ processing.processed }}
        </td>
      </tr>
      <tr data-cy="processing-remaining">
        <td>Remaining</td>
        <td>
          {{ processing.remaining }}
        </td>
      </tr>
    </tbody>
  </Table>
</template>

<script>
import Table from "@/components/Table.vue";
export default {
  components: {
    Table
  },
  props: {
    processing: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
tbody tr td:first-child {
  width: 30%;
}
</style>
